// import ElementContent from '@/components/sections/builder/elements/body/blog-post/content';
import dynamic from 'next/dynamic';

import BlogPostSubtitle from '@/components/sections/builder/elements/body/blog-post/subtitle';
import BlogPostTitle from '@/components/sections/builder/elements/body/blog-post/title';
import { BlogPostElementDataType } from '@/components/sections/builder/elements/body/blog-post/type';
import { BetweenHorizontalStart } from 'lucide-react';
import BlogPostListEmail from '@/components/sections/builder/elements/body/blog-post/post-list';

const ElementContent = dynamic(
  () =>
    import('@/components/sections/builder/elements/body/blog-post/content').then(
      (mod) => mod.default
    ),
  { ssr: false }
);

const ElementSetting = dynamic(
  () =>
    import('@/components/sections/builder/elements/body/blog-post/setting').then(
      (mod) => mod.default
    ),
  { ssr: false }
);

export const BlogPostList = BlogPostListEmail;
export const defaultData: BlogPostElementDataType = {
  name: 'Blog Post',
  contentAlign: 'center',
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const BlogPost = {
  type: 'blog_post',
  group: 'body_blog_post',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: BetweenHorizontalStart,
  defaultChilds: [BlogPostTitle, BlogPostSubtitle, BlogPostListEmail],
  childs: [BlogPostTitle, BlogPostSubtitle, BlogPostListEmail],
  isImmutable: true,
};

export default BlogPost;
